export const PASSWORD_RESET_FALLBACK_ERROR = 'Something went wrong';

export const getPasswordResetError = (data: unknown): string => {
  if (!data) {
    return PASSWORD_RESET_FALLBACK_ERROR;
  }
  if (typeof data !== 'object') {
    return '';
  }
  if ('code' in data && typeof data.code === 'string' && data.code) {
    return data.code;
  }
  if ('message' in data && typeof data.message === 'string' && data.message) {
    return data.message;
  }
  return '';
};
